/*
 * Mutation to update program
 */
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
const mutation = graphql`
mutation VppUpdateMutation($input: UpdateVppTByVppIdInput!) {
  updateVppTByVppId(input: $input) {
    vppT {
      vppId
    }
  }
}
`;

function commit(vppId, description, programName, visibility, notes, formId, repFname, repLname, repEmail, repImg, defaultParmValue,
                ctaTitle, ctaText, ctaButton, ctaLabel, ctaTitleSuspend, ctaTextSuspend, ctaTitleDecline, ctaTextDecline, ctaTitleLeft, ctaTextLeft) {
  var variables = {
    input: {
      vppId,
      vppTPatch: {}
    }
  };

  if (formId != null && formId !== -1) { variables.input.vppTPatch.formId = formId; }
  if (formId === -1) { variables.input.vppTPatch.formId = null; }

  if (description != null)      { variables.input.vppTPatch.description = description; }
  if (programName != null)      { variables.input.vppTPatch.programName = programName; }
  if (visibility != null)       { variables.input.vppTPatch.visibility = visibility; }
  if (notes != null)            { variables.input.vppTPatch.notes = notes; }
  if (repFname != null)         { variables.input.vppTPatch.repFname = repFname; }
  if (repLname != null)         { variables.input.vppTPatch.repLname = repLname; }  
  if (repEmail != null)         { variables.input.vppTPatch.repEmail = repEmail; }
  if (repImg != null)           { variables.input.vppTPatch.repImg = repImg; }
  if (defaultParmValue != null) { variables.input.vppTPatch.defaultParmValue = defaultParmValue; }
  if (ctaTitle != null)         { variables.input.vppTPatch.ctaTitle = ctaTitle; }
  if (ctaText != null)          { variables.input.vppTPatch.ctaText = ctaText; }
  if (ctaButton != null)        { variables.input.vppTPatch.ctaButton = ctaButton; }
  if (ctaLabel != null)         { variables.input.vppTPatch.ctaLabel = ctaLabel; }
  if (ctaTitleSuspend != null)  { variables.input.vppTPatch.ctaTitleSuspend = ctaTitleSuspend; }
  if (ctaTextSuspend != null)   { variables.input.vppTPatch.ctaTextSuspend = ctaTextSuspend; }
  if (ctaTitleDecline != null)  { variables.input.vppTPatch.ctaTitleDecline = ctaTitleDecline; }
  if (ctaTextDecline != null)   { variables.input.vppTPatch.ctaTextDecline = ctaTextDecline; }
  if (ctaTitleLeft != null)     { variables.input.vppTPatch.ctaTitleLeft = ctaTitleLeft; }
  if (ctaTextLeft != null)      { variables.input.vppTPatch.ctaTextLeft = ctaTextLeft; }
  
    
  return new Promise((resolve, reject) => {
    commitMutation(
      abEnvironment.getEnvironment(), {
      mutation,
      variables,
      onCompleted: (response) => {
        resolve(response);
      },
      onError: (error) => {
        reject(error);
      }
    });
  });
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };
 
